<div class="container-fluid d-flex flex-md-row flex-column vh-100 p-0 m-0">
  <!-- Left Side (Form Section) -->
  <div class="col-md-7 col-12 d-flex bg-white content-area flex-column">

    <!-- Logo -->
    <div class="d-flex flex-column mt-3 pagealign">
      <img src="assets/images/logo_images/cixor_logo.png" alt="cixor_logo_image" class="logo-img" />
    </div>

    <!-- Shared Form Container -->
    <div class="col-12 col-md-8 offset-md-2 d-flex flex-column justify-content-start flex-grow-1 mt-5">

      <!-- Greeting line (Fixed visual position) -->
      <div class="text-start mb-4">
        <p class="login-text animated-greeting">
          Welcome to CIXOR PayDay Management portal
        </p>
      </div>

      <!-- Wrapper to reserve height for forms -->
      <div class="flex-grow-1 d-flex flex-column justify-content-between">

        <!-- LOGIN FORM (default) -->
        <div *ngIf="!showOtpSection && !showForgotSection">
          <form #loginForm="ngForm" class="form" (ngSubmit)="adminlogin(loginForm)">
            <!-- Username -->
            <div class="form-group mb-4 mt-4 animated-form-group delay-1">
              <label for="forUsername" class="inputfields">Email or Username</label>
              <div class="input-wrapper">
                <input #usernameInput type="text" class="form-control input-text shadow-none pe-5" id="forUsername"
                  placeholder="Enter your email or username" name="username" ngModel required #usernameField="ngModel"
                  [ngClass]="{ 'border-danger-subtle': loginForm.submitted && usernameField.invalid }" />
                <i class="bi bi-person-fill input-icon"></i>
              </div>
            </div>

            <!-- Password -->
            <div class="form-group mb-2 animated-form-group delay-2">
              <label for="forPassword" class="inputfields">Password</label>
              <div class="input-wrapper position-relative">
                <input [type]="showPassword ? 'text' : 'password'" class="form-control input-text shadow-none pe-5"
                  id="forPassword" placeholder="********" name="password" ngModel required #passwordField="ngModel"
                  [ngClass]="{ 'border-danger-subtle': loginForm.submitted && passwordField.invalid }" />
                <i class="bi bi-key-fill input-icon"></i>
                <i class="bi password-toggle-icon" [ngClass]="showPassword ? 'bi-eye-slash-fill' : 'bi-eye-fill'"
                  (click)="togglePasswordVisibility()" role="button" tabindex="0"
                  (keypress.enter)="togglePasswordVisibility()"
                  [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
                </i>
              </div>
            </div>

            <!-- Forgot link -->
            <div class="text-end mb-4 animated-form-group delay-2">
              <a class="text-decoration-underline small" role="button" (click)="openForgotPassword()">
                Forgot password?
              </a>
            </div>

            <!-- Login Button -->
            <div class="form-group animated-form-group delay-4">
              <button type="submit" class="default-button glow-button-outline w-100 mt-2 mb-5">
                Log in
              </button>
            </div>
          </form>
        </div>

        <!-- FORGOT PASSWORD: STEP 1 (Request OTP for reset) -->
        <div *ngIf="showForgotSection && !showForgotOtpSection">
          <form #forgotForm="ngForm" class="form" (ngSubmit)="submitForgot(forgotForm)">
            <!-- Email -->
            <div class="form-group mb-4 mt-4 animated-form-group delay-1">
              <label for="forgotEmail" class="inputfields">Email</label>
              <div class="input-wrapper">
                <input type="email" id="forgotEmail" name="forgotEmail" class="form-control input-text shadow-none"
                  placeholder="Enter your email" [(ngModel)]="forgotEmail" required />
                <i class="bi bi-envelope-fill input-icon"></i>
              </div>
            </div>

            <!-- New Password -->
            <div class="form-group mb-4 animated-form-group delay-2">
              <label for="newPassword" class="inputfields">New Password</label>
              <div class="input-wrapper position-relative">
                <input [type]="showNewPassword ? 'text' : 'password'" id="newPassword" name="newPassword"
                  class="form-control input-text shadow-none" placeholder="********" [(ngModel)]="newPassword" required
                  minlength="6" />
                <i class="bi bi-shield-lock-fill input-icon"></i>
                <i class="bi password-toggle-icon" [ngClass]="showNewPassword ? 'bi-eye-slash-fill' : 'bi-eye-fill'"
                  (click)="toggleNewPasswordVisibility()" role="button" tabindex="0"
                  (keypress.enter)="toggleNewPasswordVisibility()"
                  [attr.aria-label]="showNewPassword ? 'Hide password' : 'Show password'">
                </i>
              </div>
            </div>

            <!-- Confirm Password -->
            <div class="form-group mb-4 animated-form-group delay-2">
              <label for="confirmPassword" class="inputfields">Confirm Password</label>
              <div class="input-wrapper position-relative">
                <input [type]="showConfirmPassword ? 'text' : 'password'" id="confirmPassword" name="confirmPassword"
                  class="form-control input-text shadow-none" placeholder="********" [(ngModel)]="confirmPassword"
                  required minlength="6" />
                <i class="bi bi-shield-lock input-icon"></i>
                <i class="bi password-toggle-icon" [ngClass]="showConfirmPassword ? 'bi-eye-slash-fill' : 'bi-eye-fill'"
                  (click)="toggleConfirmPasswordVisibility()" role="button" tabindex="0"
                  (keypress.enter)="toggleConfirmPasswordVisibility()"
                  [attr.aria-label]="showConfirmPassword ? 'Hide password' : 'Show password'">
                </i>
              </div>
            </div>

            <div class="d-flex gap-2 animated-form-group delay-2">
              <button type="button" class="btn btn-outline-secondary w-50" (click)="cancelForgot()">
                Cancel
              </button>
              <button type="submit" class="default-button glow-button-outline w-50">
                Continue
              </button>
            </div>
          </form>
        </div>

        <!-- FORGOT PASSWORD: STEP 2 (OTP confirm) -->
        <div *ngIf="showForgotSection && showForgotOtpSection" class="otp-section mt-4 inputfields">
          <div class="form-group mb-4">
            <label for="forgotOtpInput" class="inputfields">Enter the OTP sent to your email</label>
            <div class="input-wrapper position-relative">
              <input #forgotOtpField type="password" id="forgotOtpInput"
                class="form-control input-text shadow-none pe-5 text-center" [(ngModel)]="forgotOtp" name="forgotOtp" />
              <i class="bi bi-key-fill input-icon"></i>
            </div>
          </div>

          <!-- OTP Resend -->
          <div class="text-center mb-4">
            <span class="text-success">Didn't receive the code?</span>
            <span class="text-dark fw-semibold ms-1"
              [ngStyle]="{ 'text-decoration': running ? 'none' : 'underline', 'cursor': running ? 'default' : 'pointer' }"
              (click)="!running && resendForgotOtp()">
              Resend<span *ngIf="running"> in {{ time }} sec</span>
            </span>
          </div>

          <div class="form-group d-flex gap-2">
            <button class="btn btn-outline-secondary w-50" (click)="cancelForgot()">
              Cancel
            </button>
            <button class="default-button glow-button-outline w-50 mt-0" [disabled]="!forgotOtp"
              (click)="confirmForgotOtp()">
              Confirm Reset
            </button>
          </div>
        </div>

        <!-- LOGIN OTP Section (existing) -->
        <div *ngIf="showOtpSection && !showForgotSection" class="otp-section mt-4 inputfields">
          <div class="form-group mb-4">
            <label for="otpInput" class="inputfields">Enter your One-Time password</label>
            <div class="input-wrapper position-relative">
              <input #otpField type="password" id="otpInput"
                class="form-control input-text shadow-none pe-5 text-center" [(ngModel)]="otp" name="otp" />
              <i class="bi bi-key-fill input-icon"></i>
            </div>
          </div>

          <div class="text-center mb-4">
            <span class="text-success">I didn't receive the code,</span>
            <span class="text-dark fw-semibold ms-1"
              [ngStyle]="{ 'text-decoration': running ? 'none' : 'underline', 'cursor': running ? 'default' : 'pointer' }"
              (click)="!running && resendOtp()">
              Resend<span *ngIf="running"> in {{ time }} sec</span>
            </span>
          </div>

          <div class="form-group">
            <button class="default-button glow-button-outline w-100 mt-4 mb-5" [disabled]="!otp" (click)="confirmOtp()">
              Continue
            </button>
          </div>
        </div>

      </div>

      <!-- Footer - Inside the centered container -->
      <div class="login-footer text-center py-3 mt-auto">
        <p class="footer-text mb-0">
          <span class="version-tag">V {{ appVersion }}</span>
          <span class="mx-2">|</span>
          <span class="copyright-text">© {{ currentYear }} CIXOR. All Rights Reserved.</span>
        </p>
      </div>

    </div>

  </div>

  <!-- Right Side (Green Section with Animated Bubbles) -->
  <div class="col-md-5 col-12 green-background">
    <div class="bubble bubble-sm delay-0"></div>
    <div class="bubble bubble-lg delay-1"></div>
    <div class="bubble bubble-md delay-2"></div>
    <div class="bubble bubble-md delay-3"></div>
    <div class="bubble bubble-sm delay-4"></div>
    <div class="bubble bubble-lg delay-5"></div>
    <div class="bubble bubble-sm delay-6"></div>
    <div class="bubble bubble-md delay-7"></div>
    <div class="bubble bubble-lg delay-8"></div>
    <div class="bubble bubble-sm delay-9"></div>
    <div class="bubble bubble-lg delay-10"></div>
    <div class="bubble bubble-md delay-11"></div>
    <div class="bubble bubble-sm delay-12"></div>
    <div class="bubble bubble-md delay-13"></div>
    <div class="bubble bubble-sm delay-14"></div>
    <div class="bubble bubble-lg delay-15"></div>
    <div class="bubble bubble-md delay-16"></div>
    <div class="bubble bubble-sm delay-17"></div>
    <div class="bubble bubble-lg delay-18"></div>
    <div class="bubble bubble-md delay-19"></div>
    <div class="bubble bubble-sm delay-20"></div>
    <div class="bubble bubble-lg delay-21"></div>
    <div class="bubble bubble-md delay-22"></div>
    <div class="bubble bubble-sm delay-23"></div>
    <div class="bubble bubble-md delay-24"></div>
    <div class="bubble bubble-lg delay-25"></div>
    <div class="bubble bubble-sm delay-26"></div>
    <div class="bubble bubble-md delay-27"></div>
    <div class="bubble bubble-lg delay-28"></div>
    <div class="bubble bubble-sm delay-29"></div>
    <div class="bubble bubble-md delay-30"></div>
    <div class="bubble bubble-lg delay-31"></div>
    <div class="bubble bubble-sm delay-32"></div>
    <div class="bubble bubble-md delay-33"></div>
    <div class="bubble bubble-lg delay-34"></div>
    <div class="bubble bubble-sm delay-35"></div>
    <div class="bubble bubble-md delay-36"></div>
    <div class="bubble bubble-lg delay-37"></div>
    <div class="bubble bubble-sm delay-38"></div>
    <div class="bubble bubble-md delay-39"></div>
    <div class="bubble bubble-lg delay-40"></div>
    <div class="bubble bubble-sm delay-41"></div>
    <div class="bubble bubble-md delay-42"></div>
    <div class="bubble bubble-lg delay-43"></div>
    <div class="bubble bubble-sm delay-44"></div>
    <div class="bubble bubble-md delay-45"></div>
    <div class="bubble bubble-lg delay-46"></div>
    <div class="bubble bubble-sm delay-47"></div>
    <div class="bubble bubble-md delay-48"></div>
    <div class="bubble bubble-lg delay-49"></div>
  </div>
</div>
